var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gc-status-chip"},[_c('span',{class:{
      active: _vm.status == 'N',
      inactive: _vm.status == 'Y',
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }